import { COLORS } from '@btime/constants'
import { appendIf } from '@btime/helpers'
import { useSessionPermission } from '@btime/react-session'
import { useMemo } from 'react'

import { useNavigation } from '../../../../../utils/contexts/NavigationContext'
import { useOpenEditWebhookStaysModal } from '../../../../../utils/routes/modals/modalsActions'
import { useRemoveWebhook } from '../../_requests/remove'

export const useRowsActions = item => {
  const canEdit = useSessionPermission('editPublicToken')
  const canDelete = useSessionPermission('deletePublicToken')

  const navigate = useNavigation()

  const [deleteItems, { loading }] = useRemoveWebhook()

  // TODO - change hook to chouse based on plugin type
  const openEditWebhookModal = useOpenEditWebhookStaysModal()

  const singleOptions = useMemo(
    () => [
      ...appendIf(canEdit, {
        value: 'edit',
        icon: 'BsPencil',
        onClick: () => openEditWebhookModal({ id: item.id, service: item.service })
      }),

      ...appendIf(canDelete, {
        value: 'remove',
        color: COLORS.lightRed,
        icon: 'BsTrash',
        onClick: () => deleteItems([item.id])
      })
    ],
    [item, navigate]
  )

  return singleOptions
}
